import { render, staticRenderFns } from "./SectionAncestorsForm.vue?vue&type=template&id=6d006809&"
import script from "./SectionAncestorsForm.vue?vue&type=script&lang=js&"
export * from "./SectionAncestorsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports